export const IMG_ROOT =
  'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/';
// TODO move IMG_ROOT to urls.js
export const STATUS_LOADING = 1;

export const FormIcon = {
  'Booking Confirmation':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/Booking_confirmation.png',
  'Document Update':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/DocumentUpdate.png',
  Enquiry:
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/Enquiry_Quotation.png',
  'Freight Enquiry':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/FreightEnquire.png',
  'Insurance Cover Note':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/insurance.png',
  'Order Confirmation':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/OrderConfirmation.png',
  Quotation:
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/Icon_Quotation.png',
  'Sales Confirmation':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/Sales_Confirmation.png',
  'Shipment Advice':
    'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-broadcast/form-type/shipmentAdvice.png',
};

export const FormTypes = {
  'Booking Confirmation': [
    'qTitle',
    'qShipperCustomer',
    'qCargoName',
    'qCargoQuantity',
    'qCargoPacking',
    'qCargoType',
    'qFreightRate',
    'qShipmentFrom',
    'qShipmentTo',
    'qShipmentDate',
    'qShipmentDetails',
    'qConsigneeDetails',
    'qRemarks',
  ],
  'Document Update': [
    'qTitle',
    'qBuyer',
    'qOrderNo',
    'qProductNameCode',
    'qQuantity',
    'qContainerNo',
    'qDocument',
    'qCourierName',
    'qAWBNumber',
    'qDateSent',
    'qRemarks',
  ],
  Enquiry: [
    'qTitle',
    'qReferenceNo',
    'qSeller',
    'qBuyer',
    'qProductNameCode',
    'qQuantity',
    'qPrice',
    'qTradeTerm',
    'qPacking',
    'qSpecification',
    'qShipmentFrom',
    'qShipmentTo',
    'qShipmentDate',
    'qPaymentTerm',
    'qRemarks',
  ],
  'Freight Enquiry': [
    'qTitle',
    'qReferenceNo',
    'qShipperCustomer',
    'qCargoName',
    'qCargoQuantity',
    'qCargoPacking',
    'qCargoType',
    'qMSDS',
    'qFreightRate',
    'qShipmentFrom',
    'qShipmentTo',
    'qShipmentDate',
    'qScope',
    'qOtherCharges',
    'qRemarks',
  ],
  'Insurance Cover Note': [
    'qTitle',
    'qInsured',
    'qOrderNo',
    'qProductDescription',
    'qName',
    'qQuantity',
    'qPacking',
    'qInsuredValue',
    'qETD',
    'qPortOfLoading',
    'qVesselNameVoyage',
    'qPortOfDestination',
    'qCoverage',
    'qCertificatePolicy',
  ],
  'Order Confirmation': [
    'qTitle',
    'qReferenceNo',
    'qSeller',
    'qBuyer',
    'qProductNameCode',
    'qQuantity',
    'qUnitPrice',
    'qTradeTerm',
    'qInvoiceAmount',
    'qPacking',
    'qSpecification',
    'qShipmentFrom',
    'qShipmentTo',
    'qShipmentDate',
    'qPaymentTerm',
    'qConsignee',
    'qNotifyParty',
    'qDocumentRequired',
    'qRemarks',
  ],
  Quotation: [
    'qTitle',
    'qReferenceNo',
    'qSeller',
    'qBuyer',
    'qProduct',
    'qQuantity',
    'qPrice',
    'qTradeTerm',
    'qPacking',
    'qSpecification',
    'qOrigin',
    'qShipmentFrom',
    'qShipmentTo',
    'qShipmentDate',
    'qPaymentTerm',
    'qValidity',
    'qRemarks',
  ],
  'Sales Confirmation': [
    'qTitle',
    'qReferenceNo',
    'qSeller',
    'qBuyer',
    'qProductNameCode',
    'qQuantity',
    'qUnitPrice',
    'qTradeTerm',
    'qInvoiceAmount',
    'qPacking',
    'qSpecification',
    'qShipmentFrom',
    'qShipmentTo',
    'qShipmentDate',
    'qPaymentTerm',
    'qConsignee',
    'qNotifyParty',
    'qDocumentRequired',
    'qRemarks',
  ],
  'Shipment Advice': [
    'qTitle',
    'qBuyer',
    'qOrderNo',
    'qProductNameCode',
    'qQuantity',
    'qContainerNo',
    'qPacking',
    'qETD',
    'qVesselNameVoyage',
    'qETA',
    'qRemarks',
  ],
};

export const itemsPerBatch = 20;

export const timezones = [
  '-12',
  '-11',
  '-10',
  '-09',
  '-08',
  '-07',
  '-06',
  '-05',
  '-04',
  '-03',
  '-02',
  '-01',
  '+00',
  '+01',
  '+02',
  '+03',
  '+04',
  '+05',
  '+06',
  '+07',
  '+08',
  '+09',
  '+10',
  '+11',
  '+12',
  '+13',
];

export const packagings = [
  { en: 'Drums', zh: '桶' },
  { en: 'Bags', zh: '袋' },
  { en: 'Flexibags', zh: '液袋' },
  { en: 'Bulk Vessel', zh: '散船' },
  { en: 'IBC', zh: '液罐' },
  { en: 'Isotank', zh: '集装罐' },
  { en: 'Pallet', zh: '托盘' },
];

export const OFFICIAL_CHANNELS = [112, 186, 187];



// WEBPACK FOOTER //
// ./app/constants/misc.js